import dayjs from 'dayjs';
import { AuditOutlined } from '@ant-design/icons';
import { Card, DatePicker, Form, Input, Select } from 'antd';
import { CreateLayout } from '../../../components/layout/layout/CreateLayout';
import { ICertificateKey } from 'interfaces/courses';
import { ICourseCertificate } from 'interfaces/course_certificate';
import { IUser } from 'interfaces/users';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { useForm, useSelect } from '@refinedev/antd';
import { fullNameValidatorRule } from 'utils/validators';

export const CertificateCreate = () => {
  const { formProps, saveButtonProps } = useForm<ICourseCertificate>();
  const { selectProps: userSelectProps } = useSelect<IUser>({
    resource: 'users',
    optionLabel: 'email',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[email]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  const { selectProps: certificateKeySelectProps } = useSelect<ICertificateKey>(
    {
      resource: 'certificate_keys',
      optionLabel: 'key',
      optionValue: 'key',

      pagination: {
        mode: 'server'
      }
    }
  );

  return (
    <CreateLayout saveButtonProps={saveButtonProps}>
      <PageHeader
        title="Criar Certificado de Curso Livre"
        icon={AuditOutlined}
      />
      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Usuário"
            name="user_id"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select {...userSelectProps} />
          </Form.Item>

          <Form.Item
            label="Nome"
            name="recipient_name"
            rules={[
              { required: true, message: 'Campo obrigatório' },
              fullNameValidatorRule('Nome')
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Curso"
            name="course_name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Duração (horas)"
            name="duration_in_hours"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input type="number" />
          </Form.Item>

          <Form.Item
            label="Template"
            name="template_key"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select {...certificateKeySelectProps} />
          </Form.Item>

          <Form.Item
            label="Data de conclusão"
            name="completed_at"
            rules={[
              {
                required: true
              }
            ]}
            getValueProps={value => ({ value: value ? dayjs(value) : '' })}
          >
            <DatePicker format="DD/MM/YYYY" />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
